import "./../../theme/main.css";
import { IonCol, IonRow, IonSpinner } from "@ionic/react";
import React from "react";

const Spinner: React.FC = () => {
    return (
        <IonRow className="ion-justify-content-center ion-align-items-center ion-padding">
            <IonCol size="12" className="ion-text-center">
                <IonSpinner color="tertiary" />
            </IonCol>
        </IonRow>
    );
};

export default Spinner;
